import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { conversionTagProp, withConversionTagData, useInitConversionTagData, isDataReady } from '@bingads-webui-campaign-react/conversion-data';

import { InsertInstruction } from '../components/insert-instruction';
import { TagSVG } from '../components/tag-SVG';
import { CopyTag } from '../components/copy-tag';
import { getCopyTagViewStyle } from '../styles/copy-tag-view-styles';

const CopyTagViewUnstyled = (props) => {
  const {
    tagContext,
    onCopyCallback,
    classes,
  } = props;
  const {
    data,
  } = tagContext;

  useInitConversionTagData(tagContext);

  return (
    <div className={classNames(classes.container, 'copy-tag-view')}>
      <InsertInstruction />
      {isDataReady(data) &&
        <TagSVG
          tag={data}
        />
      }
      {isDataReady(data) &&
        <CopyTag
          tag={data}
          onCopyCallback={onCopyCallback}
        />
      }
    </div>
  );
};

CopyTagViewUnstyled.propTypes = {
  tagContext: conversionTagProp.isRequired,
  onCopyCallback: PropTypes.func.isRequired,
  classes: PropTypes.shape(_.mapObject(
    getCopyTagViewStyle(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
};

export const CopyTagView = withDefaultStyles(
  withConversionTagData(CopyTagViewUnstyled),
  getCopyTagViewStyle
);
